// packages/whiteboard/src/features/sticky/sticky-options.config.ts

import {
  FILL_ACTIONS,
  Z_ORDER_ACTIONS,
  ALIGN_ACTIONS,
  BOARD_COMMAND_ACTIONS,
  type ActionIntent,
  type OptionsCircleDef,
} from '../../optionsbar/optionsbar-actions.js';
import { composeOptionsCircle } from '../../optionsbar/parts/compose-options-circle.js';

// Optionskreis aus Einzelteilen (Notiz = 1+3): Standard-Knöpfe + Füllfarben.
const stickySvg = composeOptionsCircle([1, 3]);

/**
 * Sticky-specific optionsbar mapping (extracted from `optionsbar-config.ts`
 * per PRD-E §TR1 / Task B7). The slice owns the contract between the generic
 * optionsbar `ActionIntent` and the StickyNote property names.
 *
 * Sticky has no editable text styling — `color` is the background fill;
 * `text` is read-only on the StickyNote interface (PRD-E §TR2). Therefore
 * only the `fill` intent has a meaningful resolution; every other intent
 * is a no-op for sticky.
 */

/** Resolves an optionsbar action intent to a StickyNote property. */
export function resolveStickyProperty(intent: ActionIntent): string | null {
  switch (intent) {
    case 'fill':
      return 'color';
    default:
      return null;
  }
}

/**
 * Sticky-note optionsbar circle. Composed ENTIRELY from shared building blocks —
 * fill swatches + z-order + board commands — plus the sticky-owned intent →
 * property resolver above. The note has no bespoke action logic; it differs from
 * other circles only in its SVG and the `fill → color` mapping. (Z-order and
 * board commands are object-type agnostic and handled directly by the optionsbar
 * element, so no per-type wiring is needed.)
 */
export const STICKY_OPTIONS: OptionsCircleDef = {
  svg: stickySvg,
  actions: {
    ...FILL_ACTIONS,
    ...Z_ORDER_ACTIONS,
    ...ALIGN_ACTIONS,
    ...BOARD_COMMAND_ACTIONS,
  },
  resolveProperty: resolveStickyProperty,
};
